"use strict";

define('uikit/modules/popup',['require','exports','module','marionette','backbone','../channel','../mixins/component.mixin','../helper/dom','../templates','semantic/modules/popup'],function (require, exports, module) {
  var Mn = require('marionette');
  var Backbone = require('backbone');
  var channel = require('../channel');
  var ComponentMixin = require('../mixins/component.mixin');
  var DOMHelper = require('../helper/dom');
  var Templates = require('../templates');
  require('semantic/modules/popup');
  var DefaultContentView = Mn.ItemView.extend(ComponentMixin).extend({
    options: {
      header: '',
      text: ''
    },
    template: Templates.UIKit['default.popup']
  });
  var Popup = Mn.ItemView.extend(ComponentMixin).extend({
    className: 'ui popup',
    attributes: {
      'aria-modal': 'true'
    },
    template: Templates.UIKit['popup'],
    options: {
      content: 'default',
      transition: 'slide down',
      duration: 200,
      showOn: 'hover',
      context: 'body',
      hoverable: false,
      fluid: false,
      flowing: false,
      inverted: false,
      basic: false,
      inline: false,
      movePopup: true,
      size: '',
      width: '',
      position: 'top left',
      visible: false,
      borderless: false,
      compact: false,
      exclusive: true,
      ariaRole: 'dialog',
      targetAriaLabel: '',
      targetAriaLabelledby: '',
      triggerAriaLabel: '',
      triggerAriaLabelledby: ''
    },
    update: {
      visible: false,
      compact: false,
      borderless: false,
      ariaRole: true,
      targetAriaLabel: true,
      targetAriaLabelledby: true,
      triggerAriaLabel: true,
      triggerAriaLabelledby: true
    },
    initialize: function initialize() {
      var self = this;
      ComponentMixin.initialize.apply(this, arguments);
      this.listenTo(this, 'change:content', this._processContent);
      this._processContent();
      this.on('popup:show', function () {
        this.triggerMethod('show');
      }, this);
      this.on('popup:hidden', function () {
        var popupView = this.getPopupViews();
        popupView.trigger.$el.focus();
      });
      this.$el.on(this.$el.transition('get animationStartEvent'), function () {
        self._animating = true;
        self.triggerMethod('animation:start');
      }).on(this.$el.transition('get animationEndEvent'), function () {
        self._animating = false;
        self.triggerMethod('animation:end');
      });
    },
    _processContent: function _processContent(self, newContent, prev) {
      if (prev instanceof Backbone.View && prev !== newContent) {
        prev.$el.detach();
      }
      if (_.isString(this.content)) {
        switch (this.content) {
          case 'default':
            this._internal.content = new DefaultContentView();
            break;
        }
      } else if (this.content instanceof Backbone.View) {
        if (!this.content.isRendered && this.isRendered) {
          this.content.render();
        }
        if (this._isShown) {
          Mn.triggerMethodOn(this.content, 'before:show');
        }
        if (this._isShown) {
          Mn.triggerMethodOn(this.content, 'show');
        }
      }
    },
    _show: function _show() {
      var views = this.getPopupViews(),
        self = this;
      self.$el.removeClass('hidden');
      if (views) {
        views.trigger.$el.popup('show', function () {
          self.triggerMethod('popup:shown');
        });
      }
    },
    _hide: function _hide() {
      var views = this.getPopupViews(),
        self = this;
      if (views) {
        views.trigger.$el.popup('hide', function () {
          self.triggerMethod('popup:hidden');
        });
      }
    },
    reposition: function reposition() {
      var views = this.getPopupViews();
      if (views) {
        views.trigger.$el.popup('reposition');
      }
    },
    onPopupShow: function onPopupShow() {
      this._internal.visible = true;
    },
    onPopupHide: function onPopupHide() {
      this._internal.visible = false;
      this.$el.removeClass('hidden');
    },
    onPopupHidden: function onPopupHidden() {
      this.$el.removeClass('hidden');
    },
    onRender: function onRender() {
      var self = this;
      _.each(this._showNow ? [this._showNow] : this._popups, function (views) {
        var options = _.omit(this.options, 'content');
        options.popup = this.$el;
        options.on = this.showOn;
        options.target = views.target.el;
        _.each(['create', 'remove', 'show', 'visible', 'hide', 'hidden'], function (eventName) {
          options['on' + eventName.slice(0, 1).toUpperCase() + eventName.slice(1)] = function () {
            self.triggerMethod('popup:' + eventName, self);
          };
        });
        if (this.showOn.toLowerCase() == 'click') {
          if (!views.trigger._initialPopupListener) {
            views.trigger._initialPopupListener = true;
            views.trigger.$el.on('keydown', function (ev) {
              if (ev.keyCode == 13 & !views.trigger.disabled) {
                views.trigger.$el.popup('toggle');
              }
            });
          }
        }
        var self = this;
        this.$el.off('keydown.trigger');
        this.$el.on('keydown.trigger', function (ev) {
          if (ev.keyCode == 27) {
            self.hide();
            views.trigger.$el.focus();
          } else if (ev.keyCode == 9) {
            var focusable = DOMHelper.focusable(self.el),
              shiftKey = ev.shiftKey,
              length = focusable.length,
              focusedEl = document.activeElement;
            if (focusable.get(length - 1) == focusedEl && !shiftKey || focusable.get(0) == focusedEl && shiftKey) {
              self.hide();
              ev.preventDefault();
              views.trigger.$el.focus();
            }
          }
        });
        views.trigger.$el.popup('destroy').popup(options);
        if (this.visible) {
          this._show();
        } else {
          this._hide();
        }
      }, this);
    },
    getPopupViews: function getPopupViews() {
      return this._showNow || this._popups[0];
    },
    _setAriaAttributes: function _setAriaAttributes() {
      var popupViews = this.getPopupViews();
      this.updateElementAttributes({
        role: this.getOption('ariaRole')
      });
      if (this.getBoolOption('targetAriaLabel')) {
        popupViews.target.updateElementAttributes({
          'aria-label': this.getOption('targetAriaLabel')
        });
      }
      if (this.getBoolOption('targetAriaLabelledby')) {
        popupViews.target.updateElementAttributes({
          'aria-labelledby': this.getOption('targetAriaLabelledby')
        });
      }
      if (this.getBoolOption('triggerAriaLabel')) {
        popupViews.trigger.updateElementAttributes({
          'aria-label': this.getOption('triggerAriaLabel')
        });
      }
      if (this.getBoolOption('triggerAriaLabelledby')) {
        popupViews.trigger.updateElementAttributes({
          'aria-labelledby': this.getOption('triggerAriaLabelledby')
        });
      }
    },
    updateAttributes: function updateAttributes() {
      this._setAriaAttributes();
      this.addClass('fluid', this.getBoolOption('fluid') && this.getBoolOption('flowing')).addClass('flowing', this.getBoolOption('flowing')).addClass('inverted', this.getBoolOption('inverted')).addClass('basic', this.getBoolOption('basic')).addClass('compact', this.getBoolOption('compact')).addClass('borderless', this.getBoolOption('borderless')).addClass(this.getOption('size')).addClass(this.getOption('width'));
    },
    showNow: function showNow(targetView) {
      this._showNow = {
        trigger: targetView,
        target: targetView
      };
      if (targetView.isRendered) {
        this.render();
      } else {
        targetView.once('render', this.render, this);
      }
      this.show({
        force: true
      });
    },
    attach: function attach(triggerView, targetView) {
      var popups = this._popups || (this._popups = []);
      if (arguments.length < 2) {
        targetView = triggerView;
      }
      popups.push({
        trigger: triggerView,
        target: targetView
      });
      targetView.once('render', this.render, this);
      return this;
    }
  }, {
    WIDE: 'wide',
    VERY_WIDE: 'very wide',
    HUGE: 'huge',
    LARGE: 'large',
    SMALL: 'small',
    TOP_RIGHT: 'top right',
    TOP_LEFT: 'top left',
    BOTTOM_LEFT: 'bottom left',
    BOTTOM_RIGHT: 'bottom right'
  });
  Popup.DefaultContentView = DefaultContentView;
  channel.reply('popup', function () {
    return Popup;
  });
  module.exports = Popup;
});

